<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav" :class="mainStatus === 'online' && 'active'" @click.stop="handleClick('online')">{{
        $t("apiDoc.在线文档") }}</span>

    </div>
    <input type="text" @paste="onPaste" v-show="false">
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc v-if="apiData.onlineData" :key="apiKey" :onlineData="apiData.onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc v-if="apiData.apiTestData" :key="apiKey" :apiTestData="apiData.apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "./components/onlineDoc";
import apiTestDoc from "./components/apiTestDoc";
import * as apiService from './apiData'
import { BASE_URL } from '@/constants';
import { parseTableData } from '@/utils/index';

const apiUrlTest = '/gateway/edi/product/upsert';

export default {
  components: { onlineDoc, apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: BASE_URL + apiUrlTest,
      apiData: {
        onlineData: null,
        apiTestData: null
      },
      pasteData: ''
    };
  },
  computed: {
    apiKey() {
      return this.$route.meta.apiKey;
    }
  },
  watch: {
    apiKey: {
      handler(newVal) {
        this.mainStatus = "online";
        this.loadApiData(newVal);
      },
      immediate: true
    }
  },
  created() {

  },
  methods: {
    onPaste(event) {
      const text = event.clipboardData.getData('text/html') || event.clipboardData.getData('text/plain');
      try {
        this.pasteData = parseTableData(text);
      } catch (error) {
        console.log('解析表格数据失败:', error);
      }
    },
    loadApiData(apiKey) {
      if (!apiKey || !apiService[apiKey]) {
        console.warn(`未找到对应的API配置: ${apiKey}`);
        this.apiData = { onlineData: null, apiTestData: null };
        return;
      }

      try {
        if (typeof apiService[apiKey] === 'function') {
          this.apiData = apiService[apiKey]();
        }
      } catch (error) {
        console.error('加载API数据失败:', error);
        this.apiData = { onlineData: null, apiTestData: null };
      }
    },
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../css/apiTest.scss";
</style>